<template>
  <div>

    <!--  头部模板  -->
    <header-yjj></header-yjj>

    <!--  轮播图  -->
    <div class="slide-img" ref="slide">
      <img id="slideImg" src="../../assets/slide-1.jpg" ref="slideImg">
    </div>
    <!--  外围容器  -->
    <div class="home-container-col">
      <!--  公告  -->
<!--      <div class="notice">-->
<!--        <div class="notice-col" v-for="item in noticeList" :key="item.index">-->
<!--          <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank" style="color: black;text-decoration: none;">-->
<!--            <p style="width:100%;">【最新公告】：{{ item.title }}</p>-->
<!--          </router-link>-->

<!--        </div>-->
<!--        <div class="notice-add">-->
<!--          <router-link :to="{name:'NewsListYjj',params:{nav:'dongtai'}}" target="_blank">-->
<!--            <span>+</span>-->
<!--            <span>更多</span>-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->

      <!--  新闻及快捷服务  -->
      <div class="news">
        <div class="news-col">
            <div class="news-col-img" >
              <div v-for="(item,index) in newsList" :key="item.index" @click="gotoContent(item.id)" style="cursor:pointer">
                <div v-if="index == 0" style="height: 340px;">
                  <img :src="item.imgsrc" >
                  <p >
                    {{ item.title }}
                  </p>
                </div>
              </div>

            </div>
            <div class="news-col-list">
              <div class="news-col-list-title">
                  <h2>
                    <span>最新资讯</span>
                    <p></p>
                  </h2>
                  <p class="notice-add">
                    <router-link :to="{name:'NewsListYjj',params:{nav:'dongtai'}}" target="_blank">
                      <span>+</span>
                      <span>更多</span>
                    </router-link>

                  </p>
              </div>
              <div class="news-col-list-li">
                <ul v-for="(item,index) in newsList" :key="item.index" >
                  <li v-if="index>0&&index<=9" >
                    <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank">{{item.title}}</router-link>
                  </li>
                </ul>
              </div>
            </div>
        </div>
        <div class="news-serve">
          <h2 style="padding:20px;">
            <span style="border-right: 1px solid white;margin-right: 2px;"></span>
            <span style="border-right: 3px solid white;margin-right: 5px;"></span>
            纪念馆开馆时间
          </h2>
          <div class="kaiguan" >
            <div class="item">
              <div >
                <h2>{{ this.yjjdata.date1 }}</h2>
                <p>开馆时间</p>
              </div>
              <div>
                <span>
                  <img src="../../assets/jiantou.png" style="width:100%;">
                </span>
              </div>
              <div >
                <h2>{{ this.yjjdata.date2 }}</h2>
                <p>停止入馆时间</p>
              </div>
              <div >
                <span>
                  <img src="../../assets/jiantou.png" style="width:100%;">
                </span>
              </div>
              <div >
                <h2>{{ this.yjjdata.date3 }}</h2>
                <p>闭馆时间</p>
              </div>
            </div>
            <p style="padding-bottom: 10px;">（温馨提示：{{ this.yjjdata.abstr }}）</p>
            <div style="border-bottom: 1px white dashed;height: 1px;"></div>
            <span></span>
            <div class="item-down">
              <div style='flex: 1'>
                <a @click="showKai()" style="cursor: pointer">
                  <img src="../../assets/xuzhi.png" style="width:55%">
                  <p>开馆状态</p>
                </a>

              </div>
              <div style='flex: 1'>
                <router-link to="/yjj/article/1680465689259765865" target="_blank">
                  <img src="../../assets/xuzhi1.png" style="width:55%">
                  <p>预约讲解</p>
                </router-link>
              </div>
              <div style='flex: 1;text-align:center;'>
                <router-link to="/yjj/article/1680465689259765864" target="_blank">
                  <img src="../../assets/xuzhi2.png" style="width:55%">
                  <p>参观须知</p>
                </router-link>
              </div>
              <div style='flex: 1'>
                <router-link to="/yjj/map" target="_blank">
                  <img src="../../assets/dingwei.png" style="width:55%">
                  <p>地图导览</p>
                </router-link>
              </div>
            </div>
            <div style="margin-top: 20px;">
              <span style="padding:15px 30px;background: rgba(225,225,225,1);color:#A16222;font-size: 24px;border-radius: 5px;">
                服务咨询电话：024-48889088
              </span>
            </div>
          </div>
          <div>

          </div>
          <div>

          </div>
        </div>
      </div>

      <!--  广告栏  -->
      <div class="banner">
        <img src="../../assets/banner.jpg">
      </div>

      <!--  展馆  -->
      <div class="exhibition">
        <div class="ex-left">
          <router-link :to="{name:'DisplayListYjj',params:{nav:'zhanlan'}}">
            <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/535743534448252741.jpg" alt="">
          </router-link>

        </div>
        <div class="ex-right">
          <div class="ex-right-up">
            <h3 style="  padding:20px;">
              <span style="border-right: 1px solid white;margin-right: 2px;"></span>
              <span style="border-right: 3px solid white;margin-right: 5px;"></span>
              烽火岁月
            </h3>
            <ul style="line-height: 40px">
              <li style="  padding:0 20px;" v-for="item in fenghuoList" :key="item.index">
                <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank">
                  {{item.title}}
                </router-link>

              </li>

            </ul>
          </div>
          <div class="ex-right-down">
            <h3 style="  padding:20px;">
              <span style="border-right: 1px solid white;margin-right: 2px;"></span>
              <span style="border-right: 3px solid white;margin-right: 5px;"></span>
              英烈风采
            </h3>
            <ul style="line-height: 40px">
              <li style="  padding:0 20px;" v-for="item in yinglieList" :key="item.index">
                <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank">
                  {{item.title}}
                </router-link>

              </li>

            </ul>
          </div>
        </div>
      </div>

      <!--  文物  -->
      <div class="cultural">
        <div style="flex: 2;background: #A16222;height:600px;">
          <h2 style="padding: 20px;">
            <span style="display: inline-block;padding-bottom:3px;border-bottom:5px white solid">
              馆藏文物
              <div style="height: 1px;border-bottom: 2px solid white;position: relative;top:12px;"></div>
            </span>

          </h2>
          <p style="text-indent: 2em;line-height: 25px;padding:20px;font-size: 16px;text-align: justify;min-height: 320px ">
            东北抗日义勇军纪念馆是目前唯一经国家批准的集中展示义勇军抗战史实的纪念性场馆。馆内共展出416幅历史图片，其中有164幅是首次面世。刀枪炮弹、纸质书刊、金属瓷器、军事装备等九大类别文物共计535件，多方面、多角度展示了东北抗日义勇军在中国共产党的帮助及影响下腥风血雨的艰难抗战历程。
          </p>
          <div class="btn">
            <router-link to="/yjj/cultural">
              文物鉴赏
            </router-link>

          </div>
          <div class="btn" style="margin-top: 12px;">
            <router-link :to="{name:'CulturalListYjj',params:{nav1:'wenwu'}}">
              文物征集
            </router-link>

          </div>
        </div>
        <div style="flex: 6">
          <div style="padding: 0 10px;">
            <div style="display: flex;margin-bottom: 10px;">
              <div style="flex: 1;padding-right: 5px;height:295px;">
                <router-link :to="{name:'ImgContentYjj',params:{id:1679757916934905858,nav:'wenwu'}}">
                  <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533229760235442690.png"  style="width: 100%;height:100%">
                </router-link>

              </div>
              <div style="flex: 1;padding-left: 5px;height:295px;">
                <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533229760373855479.png"  style="width: 100%;height:100%">
              </div>
            </div>
            <div style="height:295px;">
              <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533229761665700268.png"  style="width: 100%;height:100%">
            </div>
          </div>

        </div>
        <div style="flex: 3;height:600px;">
          <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533229354377810434.png"  style="width: 100%;height:100%">
        </div>
      </div>

      <!--  友情链接  -->
      <div class="fri-links">
        <div style="padding-bottom: 10px;">
          <p style="text-align: center;color: #9E1A28;font-weight: bold">友情链接</p>
          <div style="width:45%;border-bottom: 2px solid #9E1A28;height: 5px;position: relative;bottom:15px;float: left"></div>
          <div style="width:45%;border-bottom: 2px solid #9E1A28;height: 5px;position: relative;bottom:15px;float: right"></div>
          <div style="clear: both"></div>
        </div>
        <ul>
          <li>
            <a href="http://www.918museum.org.cn/" target="_blank">沈阳“九·一八“历史博物馆</a>
            <a href="https://www.lszyjng.cn/" target="_blank">辽沈战役纪念馆</a>
            <a href="http://www.kmycjng.com/" target="_blank">抗美援朝纪念馆</a>
            <a href="https://www.leifeng.org.cn/" target="_blank">抚顺雷锋纪念馆</a>
          </li>
          <li style="padding: 10px 0;">
            <a href="http://www.hr.gov.cn/" target="_blank">桓仁政府信息网</a>
<!--            <router-link to="/" target="_blank">桓仁红色教育服务中心</router-link>-->
<!--            <router-link to="/lqs" target="_blank">李秋实纪念馆</router-link>-->
<!--            <router-link to="/kzhd" target="_blank">桓仁抗战红都服务中心</router-link>-->
            <a href="https://www.lnwnsjq.com/" target="_blank">五女山景区</a>
          </li>
        </ul>
      </div>


        <div :class="{'handler':showBox,'hider':hideBox}" @click="showKai('hide')">
          <div class="box">
            <h2 style="padding-bottom: 20px;" v-if="this.yjjdata.state == 1">当前状态:   <span style="color:#42b983;">纪念馆正常开放</span></h2>
            <h2 style="padding-bottom: 20px;" v-if="this.yjjdata.state == 0">当前状态:   <span style="color:#9E1A28;"> 设备检修，临时闭馆</span></h2>
            <hr>
            <p style="margin-top: 10px;" v-if="this.yjjdata.state == 1">纪念馆免费开放，请持本人身份证，在前台处登记入馆。</p>
            <p style="margin-top: 10px;" v-if="this.yjjdata.state == 0">正常开放后，请持本人身份证，在前台处登记入馆。</p>
          </div>
        </div>


    </div>



    <!--  底部模板  -->
    <footer-yjj></footer-yjj>

  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import {request} from "@/request/request";

export default {
  name: "HomeYjj",
  components: {
    HeaderYjj,
    FooterYjj
  },
  data(){
    return {
      newsList:[],
      noticeList:[],
      restfulUrl:'articles',
      fenghuoList:[],
      yinglieList:[],
      showBox: false,
      hideBox:true,
      currentOffsetTop: 0,
      yjjdata:{}


    }
  },
  methods:{
    showKai:function(data){
      if(data=='hide'){
        this.showBox = false;
        this.hideBox = true;
      }
      else{

        this.showBox = true;
        this.hideBox = false;

      }

    },
    getData:function(){//获取全部数据
      request({
        method:'GET',
        url:this.restfulUrl+'/yjjhomenewslist',
      }).then(res =>{
        this.newsList = res.data;
      },err=>{
        console.log(err)
      })
    },
    getDataByColumn:function (columnIdData) {
      request({
        method:'POST',
        url:this.restfulUrl+'/getbycolumn',
        data:{columnId:columnIdData}
      }).then(res =>{
        if(columnIdData == 4){

          this.noticeList.push(res.data[0]);
        }
        if(columnIdData == 12){
          this.fenghuoList = res.data;
        }
        if(columnIdData == 13){
          this.yinglieList = res.data;
        }
      },err=>{
        console.log(err)
      })
    },

    getYjjData:function (){
      request({
        method:'GET',
        url:"/yjjstate",
      }).then(res =>{
        this.yjjdata = res.data[0];
        var today = this.getWeekDay();
        if(today == 1){
          this.yjjdata.state = 0
        }

      },err=>{
        console.log(err)
      })
    },

    getWeekDay:function (){
      var now = new Date();
      var weekday = now.getDay();
      return weekday;
    },

    gotoContent:function(uid){
      this.$router.push({name:'ArticleContentYjj',params:{id:uid}});
    }
  } ,
  mounted() {
    this.getData();
    this.getYjjData();
    this.getDataByColumn(4);
    this.getDataByColumn(12);
    this.getDataByColumn(13);
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>
.hider{
  display: none;
}

.slide-img{
  width:100%;
  line-height: 0;

}

.slide-img img{
  width:100%;

}

.home-container-col{
    width:80%;
  min-width: 1400px;
    margin: 20px auto 0;

}
/*公告栏样式*/
.notice{
  padding:0 20px;
  display: flex;
  text-align: left;
  margin: 20px 0;
  font-weight: bold;
}
.notice-col{
  flex:5;
}
.notice-add{
  flex:1;
  text-align: right;

}
.notice-add a{
  color:black;
  text-decoration: none;
}
/*新闻样式*/
.news{
  display: flex;

}
.news-col{
  flex: 2;
  display: flex;
  height:380px;
}
.news-serve{
  flex:1;
  background: url("https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533248372677546193.jpg") 100% 100%;
  color: white;
  text-align: left;
}
.news-col-img{
  flex:2;
  position: relative;
  height:380px;

}
.news-col-img img{
  width: 100%;
  height: 100%;
}
.news-col-img p{
  position: absolute;
  width:100%;
  bottom:0;
  padding:10px 0;
  background: rgba(171,36,41,0.8);
  color:white;
}
.news-col-list{
  flex:2;
  line-height: 30px;
  max-width: 550px;
}
.news-col-list-li ul li{
  line-height: 35px;
}
.news-col-list-title{
  display: flex;
  padding: 5px 20px 10px;
}
.news-col-list-title h2{
  flex:5;
  text-align: left;
}
.news-col-list-title h2 span{
  display: inline-block;
  border-bottom:#9E1A28 solid 5px ;
}

.news-col-list ul {
  padding: 0 20px;
}
.news-col-list ul li{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  border-bottom: 1px #BBBBBB dashed;

}

/*广告位样式*/
.banner{
  margin:10px 0;
}

.banner img{
  width:100%;
}

.exhibition{
  display: flex;
  text-align: left;
  height:530px;
  margin-bottom: 10px;

  color: white;
}
.ex-left{
  flex:5;
  padding-right: 5px;
  height:100%;
}
.ex-right{
  flex:3;
  padding-left: 5px;
  height:100%;
}
.ex-right-up{
  background:url("https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533239694469632514.jpg");
  height:260px;
  margin-bottom: 10px;

}
.ex-right-up ul li a,.ex-right-down ul li a{
  color: white;
  text-decoration: none;
}
.ex-right-down{
  background: url("https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533239694297665930.jpg");
  height:260px;

}
.ex-left img{
  width:100%;
  height: 530px;
}

.cultural{
  display: flex;
  color: white;
  text-align: left;
  height: 600px;
  padding-bottom: 20px;
}
.cultural .btn{
  width: 85%;
  background:rgba(255,255,255,0.65);
  margin: 0 auto;padding:10px 0;
  color:#A16222;font-size: 25px;
  text-align: center;
  font-weight: bold;
  border-radius:5px;
}
.cultural .btn a{
  color:#A16222;
  text-decoration: none;
}
.fri-links{
  text-align: left;
  padding:20px 0;
}
.fri-links a,.news-col a{
  color: black;
  text-decoration: none;
  padding:10px;
}
.kaiguan{
  text-align: center;
  padding: 0 20px;
}
.kaiguan .item{
  display: flex;
}
.kaiguan .item div{
  flex:1;
  height: 65px;
}

.kaiguan .item div h2{
  font-size: 30px;
}
.kaiguan .item div p{
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kaiguan .item-down{
  display: flex;
}
.kaiguan .item-down div{
  flex:1;
  padding:10px 0;
}
.kaiguan .item-down div a{
  color: white;
  text-decoration: none;
}
.kaiguan .item-down div p{
  font-size: 15px;
  padding-top: 5px;
}



.handler {

  position: fixed;
  z-index: 2000;
  width:100%;
  min-height:2000px;
  top: 0;
  left: 0;
  box-sizing: border-box;
  transition: transform 1s ease-in-out;
  /*transform: translateY(calc(100% + 40px));*/
  background:rgba(10,10,10,0.7);

}
.box{
  width:400px;
  height:100px;
  background: white;
  position: relative;
  top: 350px;
  left: calc(50% - 200px);
  padding:50px;
}

</style>
